<template>
    <div class="final-login-wrap">
        <img src="https://storage.googleapis.com/schoollms/img/bg/curl.png" class="final-curl final-curl-top">
        <img src="https://storage.googleapis.com/schoollms/img/bg/curl.png" class="final-curl final-curl-bottom">
        <div class="final-dotfield"></div>

        <div class="final-content">
            <div class="final-logo-wrap">
                <img src="https://storage.googleapis.com/schoollms/img/schoollogo/fnlenglish.com.png" class="final-logo" alt="Logo">
            </div>

            <div class="final-title-wrap">
                <!-- <div class="final-eyebrow">Final Schools</div> -->
                <h1 class="final-title">FNL English Login</h1>
                <div class="final-underline"></div>
            </div>

            <div class="final-form">
                <div class="final-field">
                    <label class="final-label">Username</label>
                    <input :value="KullaniciAdi" @input="$emit('update:KullaniciAdi', $event.target.value)" type="text" class="final-input" placeholder="Enter your user name">
                </div>
                <div class="final-field">
                    <label class="final-label">Password</label>
                    <input :value="Sifre" @input="$emit('update:Sifre', $event.target.value)" :type="SifreTipi" class="final-input" placeholder="Enter your password">
                </div>
                <button type="button" class="final-button" @click="$emit('submit')">Log In</button>
            </div>
        </div>

        <div class="final-footer">
            <svg viewBox="0 0 1440 110" preserveAspectRatio="none" class="final-wave">
                <path d="M0,60 C360,10 1080,110 1440,40 L1440,110 L0,110 Z" fill="#17275C"></path>
                <path d="M0,52 C360,4 1080,100 1440,32" fill="none" stroke="#E2231A" stroke-width="4"></path>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: "LoginFormFinal",
    props: {
        KullaniciAdi: { type: String, default: '' },
        Sifre: { type: String, default: '' },
        SifreTipi: { type: String, default: 'password' },
        SifreIcon: { type: String, default: 'feather-eye' },
    },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@500;700;800&family=Source+Sans+3:wght@400;600&display=swap');

.final-login-wrap {
    position: relative;
    min-height: 100vh;
    background: #FBF3EA;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Source Sans 3', sans-serif;
}

.final-curl {
    position: absolute;
    width: 280px;
    z-index: 0;
    pointer-events: none;
}
.final-curl-top {
    top: -40px;
    right: -60px;
    opacity: 0.9;
    transform: rotate(10deg);
}
.final-curl-bottom {
    bottom: 120px;
    left: -70px;
    width: 220px;
    opacity: 0.8;
    transform: scaleX(-1) rotate(6deg);
}

.final-dotfield {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 110px;
    height: 60%;
    z-index: 0;
    background-image: radial-gradient(rgba(226,35,26,0.10) 1.6px, transparent 1.6px);
    background-size: 16px 16px;
}

.final-content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 56px 24px 40px;
    width: 100%;
    box-sizing: border-box;
}

.final-logo-wrap {
    margin-bottom: 36px;
}
.final-logo {
    height: 100px;
}

.final-title-wrap {
    text-align: center;
    margin-bottom: 32px;
}
.final-eyebrow {
    font-family: 'Manrope', sans-serif;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0.04em;
    color: #E2231A;
    text-transform: uppercase;
    margin-bottom: 6px;
}
.final-title {
    font-family: 'Manrope', sans-serif;
    font-weight: 800;
    font-size: 32px;
    color: #17275C;
    margin: 0 0 10px;
}
.final-underline {
    width: 120px;
    height: 4px;
    background: linear-gradient(90deg,#E2231A,#F5871F);
    margin: 0 auto;
    border-radius: 2px;
}

.final-form {
    background: transparent;
    border-radius: 20px;
    padding: 40px;
    width: 100%;
    max-width: 400px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.final-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.final-label {
    font-size: 14px;
    font-weight: 600;
    color: #17275C;
}
.final-input {
    height: 46px;
    border-radius: 10px;
    border: 1.5px solid #E4E1DC;
    padding: 0 14px;
    font-size: 15px;
    background: #FBF9F6;
}
.final-input::placeholder {
    color: #9AA3B8;
}
.final-input:focus {
    outline: none;
    border-color: #17275C !important;
    box-shadow: 0 0 0 3px rgba(23,39,92,0.10);
}
.final-button {
    height: 48px;
    border: none;
    border-radius: 10px;
    background: #E2231A;
    color: #fff;
    font-family: 'Manrope', sans-serif;
    font-weight: 700;
    font-size: 15.5px;
    cursor: pointer;
    margin-top: 4px;
}
.final-button:hover {
    background: #c91d15;
}

.final-footer {
    position: relative;
    z-index: 1;
    width: 100%;
    margin-top: auto;
}
.final-wave {
    display: block;
    width: 100%;
    height: 90px;
}
</style>
